import debug from "debug";
import plugin from '../../lib/plugin';

export const MODULE_NAME = 'app.core/modules/store-locator-search';
export const ELEMENT_SELECTOR = '[data-store-locator-search]';

const log = debug(MODULE_NAME);

export function exec() {
    const elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) { return; }
    const { StoreLocatorSearch } = require('./component');
    plugin('storeLocatorSearch', StoreLocatorSearch);
    $(elements).storeLocatorSearch();
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-locator-search/index.js